<div class="p-pb-4">
    <p-card>
        <ng-template pTemplate="header">
            <div class="p-card-title">
                Datos generales
            </div>
        </ng-template>
        <ng-template pTemplate="content">
            <div class="p-grid">
                <div class="p-col-3 p-field">
                    <label for="fechaFactura">{{'sale.entity_fields.date' | translate}}</label>
                    <input id="fechaFactura" type="text" pInputText [value]="sale?.FechaFactura | date:'shortDate'"
                        readonly />
                </div>
                <div class="p-col-3 p-field">
                    <label for="serieFactura">{{'sale.entity_fields.description' | translate}}</label>
                    <input id="serieFactura" type="text" pInputText [value]="sale?.SerieFactura" readonly />
                </div>
                <div class="p-col-3 p-field">
                    <label for="numeroFactura">{{'sale.entity_fields.number' | translate}}</label>
                    <input id="numeroFactura" type="text" pInputText [value]="sale?.NumeroFactura" readonly />
                </div>
                <div class="p-col-3 p-field">
                    <label for="razonSocial">{{'sale.entity_fields.company_name' | translate}}</label>
                    <input id="razonSocial" type="text" pInputText [value]="sale?.RazonSocial" readonly />
                </div>
            </div>
        </ng-template>
    </p-card>
</div>
<div class="p-pb-4">
    <p-card>
        <ng-template pTemplate="header">
            <div class="p-card-title">
                Líneas
            </div>
        </ng-template>
        <ng-template pTemplate="content">
            <div class="sales-lines-table">
                <p-table [value]="salesLines" [responsive]="true" responsiveLayout="scroll" [paginator]="true" [rows]="10" [loading]="loadingLines"
                    [emptyMessage]="'general.no_results' | translate">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{'transactionLine.entity_fields.article_code' | translate}}</th>
                            <th>{{'transactionLine.entity_fields.company_code' | translate}}</th>
                            <th>{{'transactionLine.entity_fields.article_description' | translate}}</th>
                            <th>{{'transactionLine.entity_fields.vat_base' | translate}}</th>
                            <th>{{'transactionLine.entity_fields.net_amount' | translate}}</th>
                            <th>{{'transactionLine.entity_fields.price' | translate}}</th>
                            <th>{{'transactionLine.entity_fields.vat_amount' | translate}}</th>
                            <th>{{'transactionLine.entity_fields.qty' | translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-line>
                        <tr>
                            <td>{{ line.CodigoArticulo }}</td>
                            <td>{{ line.CodigoEmpresa }}</td>
                            <td>{{ line.DescripcionArticulo }}</td>
                            <td>{{ line.BaseIva | number:'0,00' }}</td>
                            <td>{{ line.ImporteLiquido | number:'0,00' }}</td>
                            <td>{{ line.Precio | number:'0,00' }}</td>
                            <td>{{ line.TotalIva | number:'0,00' }}</td>
                            <td>{{ line.Unidades }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="8">{{'general.not_data' | translate }}</td>
                        </tr>
                    </ng-template>
                </p-table>

            </div>
        </ng-template>
    </p-card>
</div>

<div style="display: flex; flex-direction: column; font-weight: bold;">
    <div style="display: flex; justify-content: right; gap: 1rem;">
        <label>{{'sale.entity_fields.base' | translate}}</label>
        <label style="width: 100px; text-align: right;">{{sale?.BaseImponible | number:'0.00'}}&euro;</label>
    </div>
    <div style="display: flex; justify-content: right; gap:  1rem;">
        <label>{{'sale.entity_fields.vat' | translate}}</label>
        <label style="width: 100px; text-align: right;">{{sale?.TotalIva | number:'0.00'}}&euro;</label>
    </div>
    <div style="display: flex; justify-content: right; gap:  1rem;">
        <label>{{'sale.entity_fields.amount' | translate}}</label>
        <label style="width: 100px; text-align: right;">{{sale?.ImporteFactura | number:'0.00'}}&euro;</label>
    </div>
</div>